import PropTypes from 'prop-types'
import React from 'react'
import { CardElement } from 'react-stripe-elements'
import { Segment, Form } from 'semantic-ui-react'
import { RefType } from 'libs/custom-prop-types'

import { PaymentFormPaymentElement } from './PaymentFormPaymentElement'

// Legacy CardElement variant — the original pre-PET-2015 form. Renders when
// the caller does not pass `variant='paymentElement'` (i.e., when the
// `enable_billing_tax_id` waffle is OFF). Kept verbatim so waffle-off
// customers see identical behavior to what shipped before.
const PaymentFormCardElement = (props) => (
  <Form onSubmit={props.onSubmit}>
    <Form.Field>
      <label>Card holder name</label>
      <input type="text" name="name" value={props.name} onChange={props.onTextChange} required />
    </Form.Field>
    <Form.Field>
      <label>Address</label>
      <input
        type="text"
        name="address"
        value={props.address}
        onChange={props.onTextChange}
        required
      />
    </Form.Field>
    <Form.Group widths="equal">
      <Form.Field>
        <label>City</label>
        <input type="text" name="city" value={props.city} onChange={props.onTextChange} required />
      </Form.Field>
      <Form.Field>
        <label>State/Province</label>
        <input
          type="text"
          name="province"
          value={props.province}
          onChange={props.onTextChange}
          required
        />
      </Form.Field>
      <Form.Field>
        <label>Zip/Postal</label>
        <input type="text" name="zip" value={props.zip} onChange={props.onTextChange} required />
      </Form.Field>
    </Form.Group>
    <Form.Field>
      <Segment>
        <CardElement
          hidePostalCode
          onChange={props.onCardChange}
          style={{ base: { fontSize: '18px' } }}
        />
      </Segment>
    </Form.Field>
    <input ref={props.forwardedRef} type="submit" hidden />
  </Form>
)

// Dispatcher — picks the modern PaymentElement variant when the caller opts
// in via `variant='paymentElement'` (the modal reads
// `useFeatureToggle().enableBillingTaxId` and passes accordingly). The two
// variants intentionally have overlapping prop shapes so the modal
// integration code stays uniform; each ignores props that don't apply.
export const PaymentForm = (props) => {
  if (props.variant === 'paymentElement') {
    return (
      <PaymentFormPaymentElement
        onSaved={props.onSaved}
        onError={props.onError}
        onCompletionChange={props.onCardChange && ((complete) => props.onCardChange({ complete }))}
        onEmptyChange={props.onCardChange && ((empty) => props.onCardChange({ empty }))}
        forwardedRef={props.forwardedRef}
        onAddressChange={props.onAddressChange}
        defaultAddress={props.defaultAddress}
        taxIdField={props.taxIdField}
      />
    )
  }
  return <PaymentFormCardElement {...props} />
}

PaymentForm.propTypes = {
  // Common
  variant: PropTypes.oneOf(['cardElement', 'paymentElement']),
  forwardedRef: RefType,
  // cardElement variant only
  name: PropTypes.string,
  address: PropTypes.string,
  city: PropTypes.string,
  province: PropTypes.string,
  zip: PropTypes.string,
  onCardChange: PropTypes.func,
  onTextChange: PropTypes.func,
  onSubmit: PropTypes.func,
  // paymentElement variant only — the modern flow doesn't route submit
  // through an outer stripe.createToken; it produces a `pm_...` id directly
  // and hands it back via `onSaved`, with errors surfaced via `onError`.
  onSaved: PropTypes.func,
  onError: PropTypes.func,
  onAddressChange: PropTypes.func,
  defaultAddress: PropTypes.object,
  taxIdField: PropTypes.node,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/PaymentForm/index.js